import { cloudFunction } from 'services/parse';

export const updateOrderItemStatus = (data: Record<string, any>) => {
  return cloudFunction('updateOrderItemStatus', data);
};
